export default "__VITE_ASSET__CafyNjyb__"